import React, { useEffect, useState } from 'react';
import { ButtonDefault, FieldCheck, FieldNumber, FieldText, FieldTextArea, LoadSpin, PanelBase } from 'dw-components';
import moment from 'moment';
import { firebaseApp } from '../../../../API/firebaseApp';
import { getDatabase, ref, push, get, set } from "firebase/database";
import { message } from 'antd';

const TimelineNew = (props) => {

    const [initData, setInitData] = useState({
        name: null,
        active: true,
        created: moment().format("YYYY.MM.DD HH:mm:ss")
    });
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);
    const [checkRule, setCheckRule] = useState(false);

    const getData = async () => {
        let tData = { ...initData };
        setLoading(true);
        if (props.id) {
            await get(ref(getDatabase(firebaseApp), "timeline/" + props.id)).then(response => {
                let resp = response.toJSON();
                if (resp) {
                    tData = resp;
                }
            });
        }
        setLoading(false);

        setData(tData);
    }

    useEffect(() => {
        getData();
    }, [props.id]);

    const fieldOnChanged = async (key, text, field, fieldname) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            if (fieldname) {
                tData[fieldname] = text;
            }
            setData(tData);
        }
    }

    const onSave = async () => {

        setCheckRule(true);
        let success = false;

        let vRule = true;

        if (!data?.name
            || !data?.description
            || !data?.orderby) {
            vRule = false;
        }

        if (vRule) {
            setLoadingSave(true);
            if (props.id) {
                await set(ref(getDatabase(firebaseApp), "timeline/" + props.id), data).then(response => {
                    success = true;
                    message.success("Амжилттай");
                });
            } else {
                let tData = { ...data };
                tData.created = moment().format("YYYY.MM.DD HH:mm:ss");
                await push(ref(getDatabase(firebaseApp), "timeline"), tData).then(response => {
                    success = true;
                    message.success("Амжилттай");
                });
            }
            setLoadingSave(false);

        }
        if (success) {
            onDismiss();
            if (props.onAfterSave) {
                props.onAfterSave();
            }
        }
    }

    const onDismiss = () => {
        setCheckRule(false);
        setData({ ...initData });
        if (props.onDismiss) {
            props.onDismiss();
        }
    }

    return (
        <div>
            <PanelBase
                isOpen={props.isOpen}
                onDismiss={onDismiss}
                headerText={props.id ? "Түүхэн замнал засах" : "Түүхэн замнал нэмэх"}
                buttons={(
                    <div>
                        {loadingSave ? (<LoadSpin />) : (<ButtonDefault onClick={onSave} text="Хадгалах" />)}
                    </div>
                )}
            >
                <div style={{ marginTop: 13 }}>
                    <FieldText required loading={loading} title="Нэр" onChanged={fieldOnChanged} keyfield='name' defaultValue={data.name} checkreq={checkRule} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldTextArea required loading={loading} title="Тайлбар" onChanged={fieldOnChanged} keyfield='description' defaultValue={data.description} checkreq={checkRule} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldNumber required loading={loading} title="Эрэмбэ" onChanged={fieldOnChanged} keyfield='orderby' defaultValue={data.orderby} checkreq={checkRule} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldCheck loading={loading} title="Төлөв" onChanged={fieldOnChanged} keyfield='active' defaultValue={data.active} />
                </div>
            </PanelBase>
        </div>
    );
}

export default TimelineNew;